// Boot-time theme stamp — imported for side effect by src/index.tsx BEFORE the
// lazy App chunk loads, so the auth-gate/route skeletons render in the user's
// persisted theme instead of unthemed defaults. initTheme() is idempotent and
// the themeStore stays the single source of truth afterwards (App's own call
// becomes a no-op).
import { useThemeStore } from '@/lib/store/themeStore';

useThemeStore.getState().initTheme();
